export interface NotesContextInterface {
  data: {
    math: NotesDataInterface[];
    verbal: NotesDataInterface[];
    writing: NotesDataInterface[];
  };
  fetchData: (examSectionName: string) => void;
}

export interface NotesDataInterface {
  lessonNotes: NoteProps[];
  questionNotes: NoteProps[];
};

export interface NoteProps {
  id: number;
  text: string;
  timestamp: string;
  link: string;
  linkText: string;
}
